module.exports = __webpack_public_path__ + "img/1fie-k-niswkan.f51664c1.jpg";